import { LayoutProps } from "../../../../../../types";
import { AccessListDiff } from "../../../types";

export enum AccessDiffStatus {
  None = 0,
  Same,
  New,
  Deleted,
}

export interface AccessListDiffProps extends LayoutProps {
  access_diff: AccessListDiff;
}
